import { useMutation } from '@tanstack/vue-query'

import { request } from '@/server/core/request'

export const MUTATE_ACCOUNT_SALES_KEY = 'MUTATE_ACCOUNT_SALES'

export interface PutAccountSalesPayload {
    lineId: string
    regNo: string
    isActive: boolean
    permissionIns: boolean
    permissionEvent: boolean
}

async function putAccountSales(data: PutAccountSalesPayload) {
    return new Promise((resolve, reject) => {
        request('PUT', `/ct_api/sales/list/${data.lineId}`, { data })
            .then((res) => {
                resolve(res.data)
            })
            .catch((e) => {
                reject(e)
            })
    })
}

export default function mutateAccountSales() {
    return useMutation({
        mutationKey: [MUTATE_ACCOUNT_SALES_KEY],
        mutationFn: (payload: PutAccountSalesPayload) =>
            putAccountSales(payload)
    })
}
